import "./style.css";

export default class ArticleItem {
  static selector = ".article-item";

  constructor(block) {
    this.block = block;
  }
}
